import React, { useRef } from 'react';
import PropTypes from 'prop-types';
// import { useReactToPrint } from 'react-to-print';
import { Flex, Box, Text, Button } from 'rebass';
import useHistory from 'app/hooks/history';
import GiftCertificateStyle from './GiftCertificateStyle';
import useLocation from 'app/hooks/location';
import { useDispatch } from 'react-redux';
import { toggleNavigationVisible } from 'ui/actions';
import { OrderBreakDown } from './OrderComposer';
import Wrapper from 'gift-certificate/Wrapper';
import Banner from './Banner';

function PaymentSuccess({
  quantity,
  orderSummary,
  calculatedPricing,
  currentChildJournalId,
  book_cover_id,
  isForMyBaby,
  attributes,
  nextButtonText = "Continue",
  gift_certificate_style_id,
  onStepDown,
  showFooter,
  showCta = true,
  redemptionStatus,
  ...props
}) {

  const { push } = useHistory();
  const { pathname } = useLocation();
  const contentRef = useRef(null);
  // const handlePrint = useReactToPrint({ contentRef, preserveAfterPrint: true });
  const dispatch = useDispatch();

  return (
    <Wrapper
      hideSkip
      showFooter={showFooter}
      onSubmit={props?.onStepUp}
      // onBack={onStepDown}
      bg="aliceBlue"
      nextButtonText={isForMyBaby ? nextButtonText : 'Create certificate'}
    >
      <Box width={['92%', '92%', '700px']} maxWidth={700} mx={"auto"} sx={{ position: 'relative' }} ref={contentRef} mt={2}>
        {((redemptionStatus)?.message) && (
          <Banner
            bg={((redemptionStatus).type === 'success') ? 'successBg' : 'pinks.1'}
            color={((redemptionStatus).type === 'success') ? 'success' : 'pinks.5'}
            heading={(redemptionStatus).message || "Gift card applied successfully"}
            text={(redemptionStatus).subTitle || "You're all set to preserve and celebrate your little one's firsts"}
            p="16px"
            size={'small'}
            my={2}
          />
        )}

        <Text
          color="codGrey"
          fontFamily="Bitter"
          fontSize={30}
          fontWeight={400}
          lineHeight="120%"
          letterSpacing="-0.18px"
          textAlign="left"
        >
          Thank you for your Purchase!
        </Text>

        <GiftCertificateStyle
          isFromPreview
          isFromBookCover={pathname.includes('/get-started')}
          isFromGetStarted={!pathname.includes('/redeem-gift-certificate')}
          gift_certificate_style_id={book_cover_id || gift_certificate_style_id}
          {...props}
          name_of_recipient={pathname.includes('/get-started') ? (attributes?.name || '').replace('Journal', 'First Year') : props?.name_of_recipient}
        />

        {(showCta && currentChildJournalId && !pathname.includes('/paywall')) && <Button
          bg="brand"
          m="auto"
          sx={{
            borderRadius: '23px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 'max-content'
          }}
          onClick={() => {
            dispatch(toggleNavigationVisible(true));
            push(`/child-journals/${currentChildJournalId}${pathname.includes('watch-me-grow') ? '/watch-me-grow' : ''}`);
          }}> {pathname.includes('watch-me-grow') ? 'To Watch Me Grow!' : `Let's get started!`}</Button>}

        {orderSummary &&
          <OrderBreakDown quantity={quantity} calculatedPricing={calculatedPricing} orderSummary={orderSummary} />
        }
        {pathname.includes('watch-me-grow') ? <Flex justifyContent="center" alignItems="center" my={3}>
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40" fill="none">
            <path d="M16.6445 15.6138C16.9195 14.7888 18.0845 14.7888 18.3595 15.6138L19.972 20.4563C20.327 21.5209 20.925 22.4881 21.7187 23.2813C22.5123 24.0745 23.4799 24.672 24.5446 25.0264L29.3846 26.6389C30.2096 26.9139 30.2096 28.0789 29.3846 28.3539L24.5421 29.9664C23.4776 30.3213 22.5104 30.9193 21.7171 31.713C20.9239 32.5067 20.3264 33.4742 19.972 34.5389L18.3595 39.3789C18.3003 39.5596 18.1854 39.7169 18.0314 39.8284C17.8775 39.9399 17.6922 40 17.502 40C17.3119 40 17.1266 39.9399 16.9726 39.8284C16.8187 39.7169 16.7038 39.5596 16.6445 39.3789L15.032 34.5364C14.6773 33.4722 14.0797 32.5051 13.2865 31.7119C12.4933 30.9187 11.5263 30.3211 10.462 29.9664L5.61949 28.3539C5.43884 28.2946 5.28152 28.1798 5.16999 28.0258C5.05846 27.8718 4.99841 27.6865 4.99841 27.4964C4.99841 27.3062 5.05846 27.121 5.16999 26.967C5.28152 26.813 5.43884 26.6982 5.61949 26.6389L10.462 25.0264C11.5263 24.6717 12.4933 24.0741 13.2865 23.2808C14.0797 22.4876 14.6773 21.5206 15.032 20.4563L16.6445 15.6138ZM6.987 2.86627C7.02285 2.758 7.0919 2.66379 7.18436 2.59702C7.27681 2.53024 7.38795 2.4943 7.502 2.4943C7.61604 2.4943 7.72719 2.53024 7.81964 2.59702C7.91209 2.66379 7.98115 2.758 8.017 2.86627L8.9845 5.77128C9.41701 7.06629 10.432 8.08129 11.727 8.51379L14.632 9.4813C14.7403 9.51715 14.8345 9.5862 14.9013 9.67866C14.9681 9.77111 15.004 9.88225 15.004 9.9963C15.004 10.1103 14.9681 10.2215 14.9013 10.3139C14.8345 10.4064 14.7403 10.4755 14.632 10.5113L11.727 11.4788C11.0883 11.6916 10.508 12.0502 10.0319 12.5262C9.55592 13.0023 9.1973 13.5826 8.9845 14.2213L8.017 17.1263C7.98115 17.2346 7.91209 17.3288 7.81964 17.3956C7.72719 17.4624 7.61604 17.4983 7.502 17.4983C7.38795 17.4983 7.27681 17.4624 7.18436 17.3956C7.0919 17.3288 7.02285 17.2346 6.987 17.1263L6.01949 14.2213C5.8067 13.5826 5.44808 13.0023 4.97205 12.5262C4.49602 12.0502 3.91567 11.6916 3.27698 11.4788L0.371969 10.5113C0.263705 10.4755 0.169492 10.4064 0.102716 10.3139C0.035941 10.2215 0 10.1103 0 9.9963C0 9.88225 0.035941 9.77111 0.102716 9.67866C0.169492 9.5862 0.263705 9.51715 0.371969 9.4813L3.27698 8.51379C3.91567 8.301 4.49602 7.94238 4.97205 7.46635C5.44808 6.99032 5.8067 6.40997 6.01949 5.77128L6.987 2.86627ZM24.6596 0.243758C24.6842 0.172573 24.7305 0.110847 24.7919 0.0671609C24.8533 0.0234749 24.9267 0 25.0021 0C25.0774 0 25.1509 0.0234749 25.2123 0.0671609C25.2736 0.110847 25.3199 0.172573 25.3446 0.243758L25.9896 2.17877C26.2771 3.04377 26.9546 3.72127 27.8196 4.00877L29.7546 4.65378C29.8258 4.67846 29.8875 4.7247 29.9312 4.78608C29.9749 4.84747 29.9983 4.92094 29.9983 4.99628C29.9983 5.07162 29.9749 5.14509 29.9312 5.20647C29.8875 5.26785 29.8258 5.3141 29.7546 5.33878L27.8196 5.98378C27.3933 6.12559 27.0059 6.36482 26.6883 6.68249C26.3706 7.00016 26.1314 7.38751 25.9896 7.81379L25.3446 9.7488C25.3199 9.81998 25.2736 9.88171 25.2123 9.9254C25.1509 9.96908 25.0774 9.99256 25.0021 9.99256C24.9267 9.99256 24.8533 9.96908 24.7919 9.9254C24.7305 9.88171 24.6842 9.81998 24.6596 9.7488L24.0146 7.81379C23.8728 7.38751 23.6335 7.00016 23.3159 6.68249C22.9982 6.36482 22.6108 6.12559 22.1846 5.98378L20.2521 5.33878C20.1809 5.3141 20.1191 5.26785 20.0755 5.20647C20.0318 5.14509 20.0083 5.07162 20.0083 4.99628C20.0083 4.92094 20.0318 4.84747 20.0755 4.78608C20.1191 4.7247 20.1809 4.67846 20.2521 4.65378L22.1871 4.00877C23.0521 3.72127 23.7296 3.04377 24.0171 2.17877L24.6596 0.246258V0.243758Z" fill="#9B59B6" />
          </svg>
          <Text
            color="codGrey"
            fontFamily="Bitter"
            fontSize={30}
            fontWeight={400}
            lineHeight="120%"
            letterSpacing="-0.18px"
            textAlign="left" ml={2}
          >
            Let’s create your account now
          </Text>

        </Flex> : pathname.includes('/paywall') ?
          <Flex flexDirection="column" mb={[9, 5]}>
            <Text
              color="codGrey"
              fontFamily="Bitter"
              fontSize={30}
              fontWeight={400}
              lineHeight="120%"
              letterSpacing="-0.18px"
              textAlign="center"
              mb={4}
            >
              Continue saving precious memories!
            </Text>
            <Button
              bg="brand"
              m="auto"
              sx={{
                borderRadius: '23px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 'max-content'
              }}
              onClick={() => {
                dispatch(toggleNavigationVisible(true));
                push(`/child-journals/${currentChildJournalId}`);
                window.location.reload()
              }}> To Dashboard</Button>
          </Flex>
          : <Text
            color="codGrey"
            fontFamily="Bitter"
            fontSize={30}
            fontWeight={400}
            lineHeight="120%"
            letterSpacing="-0.18px"
            textAlign="left"
            mb={[9, 5]}
          >
            {isForMyBaby ? 'You’re on your way to creating a lasting keepsake for your baby' : 'Your thoughtful gift is almost ready.'}
          </Text>}
      </Box>
    </Wrapper>
  );
}

PaymentSuccess.propTypes = {
  id: PropTypes.string.isRequired,
};

export default React.memo(PaymentSuccess);
